export default __webpack_public_path__ + "static/media/DSC02672 Large.72fb5af1.png";